module.exports = __webpack_public_path__ + "img/RIGID PGG TRUCK_LHD_THUMB.0a59c22c.jpg";